import VerticalTabs from './VerticalTabs-compose';

export default VerticalTabs;
